import { ApplicationCheckbox } from "../../../components/application";
import usePreferredLaunchConfiguration from "../../hooks/usePreferredLaunchConfiguration";

export default function CatalogLaunchConfigurationPreferenceNote({
  entry,
  selectedConfiguration
}) {
  const {
    canPersistPreference,
    clearPreferredLaunchConfiguration,
    isPreferredSelection,
    isSaving,
    setPreferredLaunchConfiguration,
    status
  } = usePreferredLaunchConfiguration({
    entry,
    selectedLaunchConfigurationId: selectedConfiguration?.id
  });

  if (!canPersistPreference || !selectedConfiguration) {
    return null;
  }

  return (
    <div className="catalog-detail__launch-preference-note">
      <div className="catalog-detail__launch-preference-actions">
        <ApplicationCheckbox
          id={`preferred-launch-${entry.slug}-${selectedConfiguration.id}`}
          checked={isPreferredSelection}
          disabled={isSaving}
          density="compact"
          label="Use this activity mode by default."
          onChange={(event) => {
            if (event.target.checked) {
              setPreferredLaunchConfiguration();
              return;
            }

            clearPreferredLaunchConfiguration();
          }}
        />
      </div>

      {status.kind === "error" && status.message ? (
        <p
          className="catalog-detail__launch-preference-feedback"
          role="alert"
        >
          {status.message}
        </p>
      ) : null}
    </div>
  );
}
